module.exports = __webpack_public_path__ + "static/langojango-cantonese-language-phrasebook-28212e4ce60d17670bcba02d987935db.png";